module.exports = __webpack_public_path__ + "img/waiting_illustration.b7d08da8.png";